import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import 'styles/App.css'

import React from 'react'
import { parse } from 'query-string'
import Tracking from '@ta-interaktiv/react-tracking'
import { PollingResults } from '@ta-interaktiv/react-pollingresults'

function AppComponent (props) {
  // Use query string to decide what data to load
  let query = parse(window.location.search)

  // First security check: die if we don't have the proper query or if the
  // query doesn't have the proper format
  if (!('abstimmung' in query) || !/\d{8}/.test(query.abstimmung)) {
    console.group('Abstimmungsumfragen-Visualisierung')
    console.warn(
      'Sorry, but no proper information to load the data has been found. Please refer to the documentation at the location below on how to embed this visualisation.'
    )
    console.info(
      'https://confluence.tamedia.ch/display/IN/Abstimmungsumfragen-Visualisierung'
    )
    console.groupEnd()

    return null
  }

  return (
    <div className='index'>
      <PollingResults abstimmung={parseInt(query.abstimmung, 10)} />
      <Tracking />
    </div>
  )
}

export default AppComponent



// WEBPACK FOOTER //
// ./src/components/main/Main.js